import { ProcedureSet, ProcedureSets } from '../types/Procedure';

import { baseApi } from './baseApi';

export const procedureApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['Patient', 'Procedure', 'Threads'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getProcedure: builder.query<ProcedureSet, void>({
        query: () => 'api/v4/procedure',
        providesTags: ['Procedure'],
      }),
      getProcedureSets: builder.query<ProcedureSets[], void>({
        query: () => 'api/v4/episodes',
      }),
      setProcedureSet: builder.mutation({
        query: () => {
          return {
            url: 'api/v4/episodes/set_selected',
            method: 'POST',
          };
        },
        invalidatesTags: ['Patient', 'Procedure', 'Threads'],
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetProcedureQuery,
  useLazyGetProcedureQuery,
  useGetProcedureSetsQuery,
  useSetProcedureSetMutation,
} = procedureApi;
